export const environment: { production: boolean; apiUrl: string; s3Url:string } = {
  production: false,
  apiUrl: 'https://stg.iasca.netoyed.com/api',
  s3Url: 'https://iascaportal.s3.ap-south-1.amazonaws.com/'
};
